export default __webpack_public_path__ + "static/media/alur-box-2.be38d76a.png";